"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerDocumentDto = void 0;
const CustomerProfileDto_1 = require("../customer-profiles/CustomerProfileDto");
class CustomerDocumentDto {
    constructor(params) {
        this.name = "";
        this.fileUrl = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.customerProfileId = params.customerProfileId;
        this.name = params.name;
        this.fileUrl = params.fileUrl;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.vin = params.vin;
        if (params.customerProfile !== undefined) {
            this.customerProfile = params.customerProfile ?
                new CustomerProfileDto_1.CustomerProfileDto(params.customerProfile) :
                null;
        }
    }
}
exports.CustomerDocumentDto = CustomerDocumentDto;
//# sourceMappingURL=CustomerDocumentDto.js.map